// Type identity: every register has its own colour, icon and name (orange stays the colour for actions).
import { TYPE_LOOK, type ItemType } from '../lib/registers';

export function TypeIcon({ type, size = 20 }: { type: ItemType; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {TYPE_LOOK[type].icon.split('|').map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}

/** Small coloured tag ("RFI", "NOTICE"…) — used in lists, headers and comments. */
export function TypeTag({ type, label }: { type: ItemType; label?: string }) {
  const l = TYPE_LOOK[type];
  return (
    <span className="type-tag" style={{ background: l.color }}>
      {label ?? l.tag}
    </span>
  );
}

/** Big type tile at the top of an item page. */
export function TypeTile({ type }: { type: ItemType }) {
  const l = TYPE_LOOK[type];
  return (
    <div className="type-tile" style={{ background: l.color }} aria-hidden="true">
      <TypeIcon type={type} size={24} />
      <b>{l.tag}</b>
    </div>
  );
}
